import classNames from 'classnames';
import { FC } from 'react';
import { ConnectionService } from '../../types/takerConnect';
import { localeStore } from '~/mobx/localesStore';
import { TBooleanInNumber } from '~/types/main';
import { InputWithTextInside, MaskedInput } from '~/view/components/Controls/Inputs';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import Text from '~/view/components/Text/Text';
import './style.scss';

interface IProps {
  type: ConnectionService;
  status: TBooleanInNumber;
  priority: string;
  smsKey: string;
  onStatusChange: (status: TBooleanInNumber) => void;
  onPriorityChange: (value: string | undefined) => void;
  onSmsKeyChange: (value: string | undefined) => void;
}

const SmsPlatformControls: FC<IProps> = (props: IProps): JSX.Element => {
  const { type, status, priority, smsKey, onStatusChange, onPriorityChange, onSmsKeyChange } = props;

  const handlePriorityChange = (value: string | undefined) => {
    if (value === '0') return;
    onPriorityChange(value);
  };

  return (
    <div>
      <div className="sms-platform-controls__status-block">
        <div className="d-flex align-items-center">
          <Switcher status={status} onChange={onStatusChange} />
          <Text type="switcher-label" text={localeStore.t(platformTextOptions[type].status)} />
        </div>

        <InputWithTextInside
          type="number"
          value={priority}
          onChangeValue={handlePriorityChange}
          placeholder="1"
          textProps={{ text: 'takergo_priority' }}
          maxLength={2}
          contentClassName={classNames('sms-platform-controls__input', { 'd-none': !status })}
        />
      </div>

      {status ? (
        <div className="mt-5">
          <Text type="block-header" text={localeStore.t(platformTextOptions[type].keyInput)} />
          <MaskedInput
            value={smsKey}
            onChangeValue={onSmsKeyChange}
            placeholder={localeStore.t('Value')}
            className="mt-2"
            contentClassName="full-width"
          />
        </div>
      ) : null}
    </div>
  );
};

const platformTextOptions: { [key in ConnectionService]: { status: string; keyInput: string } } = {
  [ConnectionService.Unifonic]: {
    status: 'unifonic',
    keyInput: 'unifonic_sms_key',
  },
  [ConnectionService.Msegat]: {
    status: 'msegat',
    keyInput: 'msegat_key',
  },
};

export default SmsPlatformControls;
